import Marquee from "react-fast-marquee";

const items = [
  "Ръчно изработени",
  "Уникални дизайни",
  "Изкуство от цветя",
  "Вечна свежест",
  "Изработени с любов",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-line bg-sand py-8" data-testid="marquee">
      <Marquee speed={40} gradient={false}>
        {items.concat(items).map((t, i) => (
          <span key={i} className="mx-16 font-serif text-3xl sm:text-4xl text-ink flex items-center">
            {t}
            <span className="text-clay mx-16 text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
